import "react-app-polyfill/ie11";
import "core-js/modules/es.string.includes";
import "core-js/modules/es.string.starts-with";

import gfyw from "./controllers/gfyw";
import common from "./controllers/common";
import homepage from "./controllers/homepage";
import error404 from "./controllers/error404";
import section from "./controllers/section";
import gamescreen from "./controllers/gamescreen";
import gamescreenfull from "./controllers/gamescreenfull";

window.jsLoaded = true;

function App() {
	function init() {
		if ($("body").attr("data-section")) {
			_routes($("body").attr("data-section"));
		} else {
			_routes("default");
		}
	}
	function _routes(section) {
		section = section.replace(/-/g, "");
		if (section == "home") {
			section = "homepage";
		}
		window.section = section;

		common();

		if (typeof eval(`_controllers.${section}`) === "function") {
			eval(`_controllers.${section}()`);
		}
	}
	const _controllers = {
		homepage,
		error404,
		section,
		gamescreen,
		gamescreenfull,
		gfyw,
	};
	return {
		init,
	};
}
$(() => {
	new App().init();
});
